import React from 'react'
// ##
import SectionsTable from '../../modules/Section/components/SectionsTable'

export default function SectionPage() {
  return <SectionsTable />
}
